// Static data for Settings pages
// This file contains all mock data needed to display settings features without API calls

// File Extensions
export const STATIC_FILE_EXTENSIONS = [
  '.js', '.jsx', '.ts', '.tsx', '.py', '.java', '.go', '.rb', '.php',
  '.json', '.yaml', '.yml', '.env', '.properties', '.conf', '.config',
  '.sh', '.bash', '.zsh', '.ps1', '.bat', '.cmd', '.sql', '.md', '.txt'
];

// Users Data
export const STATIC_USERS = [
  {
    id: '1',
    _id: '1',
    email: 'admin@stackguard.com',
    fullname: 'Admin User',
    role: 'root',
    position: 'System Administrator'
  },
  {
    id: '2',
    _id: '2',
    email: 'john.doe@example.com',
    fullname: 'John Doe',
    role: 'admin',
    position: 'Security Lead'
  },
  {
    id: '3',
    _id: '3',
    email: 'jane.smith@example.com',
    fullname: 'Jane Smith',
    role: 'member',
    position: 'Developer'
  },
  {
    id: '4',
    _id: '4',
    email: 'bob.wilson@example.com',
    fullname: 'Bob Wilson',
    role: 'member',
    position: 'DevOps Engineer'
  },
  {
    id: '5',
    _id: '5',
    email: 'alice.brown@example.com',
    fullname: 'Alice Brown',
    role: 'admin',
    position: 'Security Analyst'
  }
];

// Current User (me)
export const STATIC_CURRENT_USER = {
  id: '1',
  _id: '1',
  email: 'admin@stackguard.com',
  fullname: 'Admin User',
  role: 'root',
  position: 'System Administrator'
};

// Configuration Data
export const STATIC_CONFIG_DATA = {
  // Version Control
  github_pat: 'ghp_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  gitlab_pat: 'glpat-xxxxxxxxxxxxxxxxxxxx',
  bitbucket_pat: 'ATBBxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  bitbucket_workspace: 'my-workspace',
  gitea_pat: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  gitea_instance_url: 'https://gitea.example.com',
  
  // Communication Services
  jira_url: 'https://mycompany.atlassian.net',
  jira_username: 'user@example.com',
  jira_api_token: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  jira_project_key: 'PROJ',
  
  // Cloud Storage
  aws_access_key_id: 'AKIAIOSFODNN7EXAMPLE',
  aws_secret_access_key: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
  aws_region: 'us-east-1',
  
  // Azure
  azure_tenant_id: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  azure_client_id: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  azure_client_secret: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  azure_storage_account: 'mystorageaccount',
  
  // GCP
  gcp_project_id: 'my-gcp-project',
  gcp_private_key_id: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  gcp_private_key: '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----\n',
  gcp_client_email: 'service-account@my-project.iam.gserviceaccount.com',
  gcp_client_id: '123456789012345678901',
  gcp_auth_uri: 'https://accounts.google.com/o/oauth2/auth',
  gcp_token_uri: 'https://oauth2.googleapis.com/token',
  gcp_auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
  gcp_client_x509_cert_url: 'https://www.googleapis.com/robot/v1/metadata/x509/service-account%40my-project.iam.gserviceaccount.com',
  
  // Vaults
  hashicorp_vault_address: 'https://vault.example.com:8200',
  hashicorp_vault_token: 's.xxxxxxxxxxxxxxxxxxxxxxxx',
  aws_parameter_store_region: 'us-east-1',
  gcp_secret_manager_project_id: 'my-gcp-project',
  azure_key_vault_name: 'my-key-vault',
  azure_key_vault_tenant_id: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  azure_key_vault_client_id: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  azure_key_vault_client_secret: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  
  // AI Models
  openai_api_key: 'sk-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  anthropic_api_key: 'sk-ant-api03-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  groq_api_key: 'gsk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  huggingface_api_key: 'hf_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  
  // Ticketing
  service_now_instance_url: 'https://mycompany.service-now.com',
  service_now_username: 'admin',
  service_now_password: 'xxxxxxxxxxxx',
  
  // Teams
  teams_webhook_url: 'https://outlook.office.com/webhook/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx@xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx/IncomingWebhook/xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  
  // Slack
  slack_webhook_url: 'https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX',
  
  // SendGrid
  sendgrid_api_key: 'SG.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx.xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  
  // Postman
  postman_api_key: 'PMAK-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
  
  // Other settings
  site_name: 'StackGuard',
  email_notifications: true
};

// Storage Accounts
export const STATIC_STORAGE_ACCOUNTS = [
  {
    id: '1',
    name: 'production-s3-bucket',
    provider: 's3',
    region: 'us-east-1',
    status: 'active',
    created_at: '2024-01-15T10:30:00Z'
  },
  {
    id: '2',
    name: 'staging-storage',
    provider: 's3',
    region: 'us-west-2',
    status: 'active',
    created_at: '2024-02-20T14:15:00Z'
  },
  {
    id: '3',
    name: 'backup-azure-blob',
    provider: 'azure-blob',
    region: 'eastus',
    status: 'active',
    created_at: '2024-03-10T09:00:00Z'
  },
  {
    id: '4',
    name: 'gcs-archive',
    provider: 'gcs',
    region: 'us-central1',
    status: 'active',
    created_at: '2024-03-25T16:45:00Z'
  }
];

// Vault Provider Accounts
export const STATIC_VAULT_PROVIDER_ACCOUNTS = {
  aws_parameter_store: [
    {
      id: '1',
      name: 'prod-parameters',
      region: 'us-east-1',
      path: '/prod/',
      status: 'active'
    },
    {
      id: '2',
      name: 'dev-parameters',
      region: 'us-west-2',
      path: '/dev/',
      status: 'active'
    }
  ],
  gcp_secret_manager: [
    {
      id: '1',
      name: 'production-secrets',
      project_id: 'my-gcp-project',
      status: 'active'
    },
    {
      id: '2',
      name: 'staging-secrets',
      project_id: 'my-gcp-project',
      status: 'active'
    }
  ]
};

// Report Data
export const STATIC_REPORT_DATA = {
  summary: {
    total_findings: 1245,
    active_findings: 890,
    unvalidated_findings: 355,
    risk_score: 72
  },
  repositories: [
    {
      name: 'my-app',
      active: 120,
      unvalidated: 45,
      total: 165
    },
    {
      name: 'api-service',
      active: 95,
      unvalidated: 32,
      total: 127
    }
  ],
  iamTags: {
    root_account_access_keys_present: 12,
    privilege_escalation: 8,
    over_permissive_access: 45,
    data_exposure: 23,
    credential_risk: 34,
    iam_policies_with_full_administrative_privileges: 19,
    identity_misuse: 15,
    misconfiguration: 28,
    compliance_gap: 16,
    general_security_risk: 22
  },
  trends: {
    dates: ['2024-01-01', '2024-01-02', '2024-01-03'],
    values: [70, 72, 71]
  }
};

// Validation Status (for showing validation states)
export const STATIC_VALIDATION_STATUS = {
  github: 'valid',
  gitlab: 'valid',
  bitbucket: 'valid',
  gitea: 'unknown',
  aws: 'valid',
  azure: 'valid',
  gcp: 'valid',
  jira: 'valid',
  openai: 'valid',
  anthropic: 'valid',
  groq: 'unknown',
  huggingface: 'valid'
};

// Manage Scans Data
export const STATIC_REPOSITORIES = [
  { id: '1', name: 'my-app', provider: 'github', selected: false },
  { id: '2', name: 'api-service', provider: 'github', selected: true },
  { id: '3', name: 'frontend', provider: 'gitlab', selected: false },
  { id: '4', name: 'backend', provider: 'bitbucket', selected: true },
  { id: '5', name: 'mobile-app', provider: 'github', selected: false }
];

export const STATIC_CLOUD_INFRA = ['AWS', 'Azure', 'GCP'];
export const STATIC_SAAS_APPS = ['Slack', 'Notion', 'Figma'];

